import axios from "../axios";

const api = {
  getDecarbonization(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/decarbonization", config).then(({ data }) => data);
  },

  getChartData(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/decarbonization/chart", config).then(({ data }) => data);
  },

  updateDecarbonization(newData, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put("/decarbonization", newData, headers).then(({ data }) => data);
  },

  loadLevers(accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put("/decarbonization/actual-levers", {}, headers).then(({ data }) => data);
  },

  updatePathwaySelection(newData, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put("/decarbonization/pathway-selection", newData, headers).then(({ data }) => data);
  },

  updateEstimatedGrowth(newData, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}`, 'Content-Type': 'application/json', } };
    return axios.patch("/decarbonization/estimated-yearly-emissions-growth", newData, headers).then(({ data }) => data);
  },

  exportDecarbonizationData( year, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/decarbonization/export?year=${year}`,
      config).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "Decarbonization Export - " + year;
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
}

export default api;